import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CardHeader } from './CardHeader';
import { useModal } from '@/hooks/useModal';
import { PurchaseModal } from './Modals/PurchaseModal';
import { storeListings } from '@/helpers/storeListings';
import type { GameThemeId } from '@skillscratch/shared-types';
import { centsToPrettyDollars } from '@skillscratch/shared-util';
import { ChangingNumbers } from './Game/ChangingCents';


export function TrendingCard() {
  const { openModal } = useModal();

  const paydayBonanza = storeListings[0];

  const handleClick = () => {
    openModal(<PurchaseModal id={paydayBonanza.id as GameThemeId} prices={paydayBonanza.prices} />);
  };

  return (
    <Card className="max-w-md rounded-lg overflow-hidden shadow-md bg-white border-0">
      <CardHeader title="Trending Card" />
      <CardContent className="p-0">
        {/* Main content */}
        <div className="px-6 pt-6 pb-4 text-center">
          {/* Title */}
          <h2 className="text-4xl font-bold text-red-500 mb-4">
            10X Payday<br />Bonanza
          </h2>
          
          {/* Prize amount */}
          <div className="text-5xl font-semibold text-slate mb-4">
            $<ChangingNumbers from={0}  to={485000} decimals={0} />
          </div>
          
          {/* Status and price */}
          <div className="flex items-center justify-center gap-4 text-lg mb-4">
            <span className="text-slate text-xl">Very Popular</span>
            <div className="h-6 border-l border-gray-200 translate-y-0.5" />
            <span className="text-slate text-xl">Price: {centsToPrettyDollars(paydayBonanza.prices[0].price, 'round')}</span>
          </div>
        </div>
        
        {/* CTA Button */}
        <div className="flex justify-center mb-4">
            <Button 
            className="py-6 bg-red-500 hover:bg-red-600 text-white text-2xl font-bold px-16 rounded-lg"
            shine
            onClick={() => handleClick()}
            >
                START WINNING
            </Button>
        </ div>
      </CardContent>
    </Card>
  );
};